const toISO8601Format = (raw, date) =>
  /^\d{4}-\d{2}-\d{2}/.test(raw)
    ? raw.slice(0, 10)
    : date.toISOString().split('T')[0];

export const getPriceValidUntil = promotion => {
  if (!promotion) return null;
  if (promotion.startDate) {
    const startDate = new Date(promotion.startDate);
    // check if startDate is valid and it's in future
    if (
      !Number.isNaN(startDate.getTime()) &&
      startDate.getTime() > Date.now()
    ) {
      return toISO8601Format(promotion.startDate, startDate);
    }
  }
  if (promotion.endDate) {
    const endDate = new Date(promotion.endDate);
    // check if endDate is valid and it's in future
    if (!Number.isNaN(endDate.getTime()) && endDate.getTime() > Date.now()) {
      return toISO8601Format(promotion.endDate, endDate);
    }
  }
  return null;
};
